import "vanilla-cookieconsent/dist/cookieconsent.css"
import "vanilla-cookieconsent/dist/cookieconsent.js"
import {cookieContent} from "assets/cookieContent"

let ccInstance = null
let onConsentListener = null
let onChangeListener = null
let isFirstTime = true
const getCCInstance = () => {
  if (!ccInstance) {
    ccInstance = initCookieConsent()
  }

  return ccInstance
}

export const openCCSettings = () => {
  const cc = getCCInstance()

  cc.showSettings()
}

export const runCookieConsent = async (currentRevision, language = 'es', firstTime = true, onConsent = null, onChange = null) => {
  const cc = getCCInstance()
  const translations = getTranslations(language)

  isFirstTime = firstTime
  onConsentListener = onConsent
  onChangeListener = onChange
  const ccConfig = {
    revision: currentRevision,
    current_lang: language,
    auto_clear_cookies: true,
    hide_from_bots: true,
    page_scripts: false,
    autorun: true,
    categories: {
      necessary: {
        enabled: true,
        readOnly: true
      }
    },
    gui_options: {
      consent_modal: {
        layout: 'bar',         // box/cloud/bar
        position: 'bottom center',   // bottom/middle/top + left/right/center
        transition: 'slide',
        swap_buttons: true
      },
      settings_modal: {
        layout: 'box',         // box/bar
        // position: 'left',       // left/right
        transition: 'slide'      // zoom/slide
      },
    },
    languages: translations,
    onAccept: onConsentAccept,
    onChange: onConsentChange
  }

  cc.run(ccConfig)
}

function onConsentAccept(cookie) {
  if (onConsentListener && isFirstTime) {
    onConsentListener(cookie)
  }
}

function onConsentChange(cookie) {
  if (onConsentListener && !isFirstTime) {
    onConsentListener(cookie)
  }
}

function getTranslations(language = 'es') {
  const cookieTextContent = cookieContent
  const config = {}
  config[language] = cookieTextContent[language]

  return config
}
